const bind = function () {
    $('.showInvoiceSlider').on('change', function () {
        if (this.checked) {
            $('#invoiceSlider').removeClass('d-none');
        } else {
            $('#invoiceSlider').addClass('d-none');
        }
    });
    if ($('.showInvoiceSlider').prop('checked')) {
        $('#invoiceSlider').removeClass('d-none');
    } else {
        $('#invoiceSlider').addClass('d-none');
    }
};

export {
    bind,
}